<div class="body_container">
  <!--cdkDropListGroup -->
  <div id="html2Pdf" class="rightPanel d-flex flex-column h-100">
    <div class="row">
      <div class="col-md-12" style="margin-top:3px">
        <div class="topPanel marginForLogs">
          <h4 style="font-size:1.3rem; margin-left:6px"><span class="bi bi-speedometer"></span> Dashboard</h4>
          <span *ngIf="isGrafanaConfigured">
            Switch To Grafana
            <mat-slide-toggle [(ngModel)]="switchToGrafanaDashboard"
                              (change)="onToggleChange($event)"></mat-slide-toggle>
          </span>
          <span
            id="labelLastUpdate"
            title="{{ lastRefreshedTime | date : 'yyyy-MM-dd, HH:mm:ss' }}"
          >
            Last Update :
            {{ lastRefreshedTime | date : "yyyy-MM-dd, HH:mm:ss" }}
          </span>
          <div>&nbsp;&nbsp;
            <button
                    type="button"
                    
                    class="actionBtn"
                    (click)="editColoum()" style="border:none"
                    triggers="hover" ngbTooltip="Select charts to be shown">
              <span><i class="bi bi-sliders"></i></span></button>
          </div>
          <button type="button"
                  class="actionBtn"
                  
                  (click)="refreshComponent()"
                  style="border:none"
                  triggers="hover" ngbTooltip="Refresh">
            <span class="bi bi-arrow-clockwise"></span>
          </button>
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>

    <div *ngIf="switchToGrafanaDashboard == false"
      class="d-flex flex-column flex-grow-1 p-2"
      style="overflow-x: hidden; overflow-y: scroll"
    >
      <!-- tiles -->
      <div class="row card-group text-center position-relative"><!-- cdkDropList [cdkDropListData]="dashboardData" (cdkDropListDropped)="drop($event)" -->
        <div class="my-2 col-md-15 col-sm-3" *ngFor="let db of dashboardData; let i= index" > <!-- cdkDrag -->
          <div *ngIf="editedColumnList.includes(db.name)" class="card row m-0 mb-3">
            <div class="card-header border-bottom-0 px-1 pb-0 d-flex align-items-center">
              <figure (click)="onDataClick(db, -1)">
                <blockquote
                  class="blockquote"
                  [ngClass]="db.subTitle != '' ? 'mb-3' : 'm-0'"
                >
                  <h3 class="my-0 fw-bold text-dark flex-grow-1 text-start">
                    <i
                      class="bi synchpc-primary text-dark fs-4"
                      [ngClass]="db.icon"
                    ></i>
                    {{ db.title }}
                  </h3>
                </blockquote>
                <figcaption
                  [ngClass]="db.subTitle == '' ? 'p-2' : 'blockquote-footer'"
                >
                  <cite title="Source Title">{{ db.subTitle }}</cite>
                </figcaption>
              </figure>
              <div [ngClass]="db.subTitle != '' ? 'iconMargin' : ''">
                <button
                  [id]="i"
                  type="button"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="bi bi-three-dots-vertical"></i>
                </button>

                <ul class="dropdown-menu" [aria-labelledby]="i">
                  <li>
                    <a class="dropdown-item" (click)="removeTile(db)">Remove</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="d-flex flex-column align-items-center mt-1">
                  <div
                   class=""
                   (click)="onDataClick(db, 0)"
                   style="cursor: pointer;"
                   >
                    <div
                    class="lh-1"
                    [style.color]="db.color"
                    style="letter-spacing: -0.025em; font-size: 3rem"
                  >
                    {{ db.data[0] }}
                  </div>
                  <div
                    class="text-lg font-medium"
                    [style.color]="db.color"
                    style="font-size: 1.2rem"
                  >
                    {{ db.labels[0] }}
                  </div>
                  </div>
                  <div class="d-flex justify-content-evenly w-100">
                    <ng-container
                      *ngFor="let label of db.labels; let i = index"
                    >
                      <div
                        *ngIf="i !== 0 && label !== ' '"
                        class="d-flex flex-column alignitems-baseline justify-content-center w-100 mt-3 text-secondary"
                        style="cursor: pointer;"
                        (click)="onDataClick(db, i)"
                      >
                        <div class="text-md font-medium truncate">
                          {{ label }}
                        </div>
                        <div class="completedVal font-medium mt-2">
                          {{ db.data[i] }}
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ngx-spinner
          bdColor="rgba(0, 0, 0, 0.1)"
          size="default"
          zIndex="1"
          color="#0072c6"
          type="ball-spin"
          name="tiles"
          [fullScreen]="false">
        </ngx-spinner>
      </div>

       <!--! Custom Data View -->
       <div
       *ngIf="customDataArray !== undefined || customDataArray !== 0"
       class="p-3 card-group row"
     >
       <div
         *ngFor="let customData of customDataArray; index as i"
         class="customCard p-2"
         [ngClass]="checkLengthCustomArray(i)"
       >
         <div class="content-wrapper border border-rounded rounded-2 p-3">
           <h3>
             <span
               [matTooltip]="customData.description"
               matTooltipPosition="right"
               >{{ customData.title }}</span
             >
           </h3>
           <hr />

           <div class="table-container">
             <table class="table table-striped">
               <thead>
                 <tr class="table-list-head">
                   <th *ngFor="let head of customData.header">{{ head }}</th>
                 </tr>
               </thead>
               <tbody>
                 <tr class="table-list-row" *ngFor="let innerObj of customData.body">
                   <td *ngFor="let head of customData.header">
                     {{ innerObj[head] }}
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
           <!--End of table container-->
         </div>
         <!--End of content wrapper-->
       </div>
       <!--End of custom card-->
     </div>
     <!--End of custom data component-->
     <!--! End of Custom Data View -->


      <div class="w-100 d-flex flex-wrap justify-content-evenly" style="background-color: aliceblue;">
        <div class="w-48 mt-4 p-3 pt-0 gaugeBlock shadow_block position-relative">
          <div class="mt-5 text-center"><label for="" class="fw-bold fs-6">Node utilization of last 1 Hour</label></div>
          <div class="gauges d-flex justify-content-evenly">
            <div class="guage" (click)="navigateToComponent('cpu')">
              <ngx-gauge
                matTooltip="Real-time average CPU percentage of all active nodes"
                style="cursor: pointer; font-size: 1rem !important"
                [size]="gaugeSize"
                type="arch"
                cap="round"
                [value]="cpuGaugeValue"
                [label]="cpuGaugeLabel"
                matTooltipPosition="above"
                [thick]="gaugeThick"
                [thresholds]="gaugeThresholds"
                [append]="gaugeAppendText"
                (mouseenter)="onCpuGaugeHover()"
                (mouseleave)="onCpuGaugeHover()"
              >
              </ngx-gauge>
            </div>
            <div class="guage" (click)="navigateToComponent('ram')">
              <ngx-gauge
                matTooltip="Real-time average RAM percentage of all active nodes"
                style="
                  cursor: pointer;
                  overflow: inherit;
                  font-size: 1rem !important;
                "
                [size]="gaugeSize"
                matTooltipPosition="above"
                type="arch"
                cap="round"
                [value]="ramGaugeValue"
                [label]="ramGaugeLabel"
                [thick]="gaugeThick"
                [thresholds]="gaugeThresholds"
                [append]="gaugeAppendText"
                (mouseenter)="onRamGaugeHover()"
                (mouseleave)="onRamGaugeHover()"
              >
              </ngx-gauge>
            </div>
            <div class="guage" (click)="navigateToComponent('gpu')">
              <ngx-gauge
                matTooltip="Real-time average GPU Memory percentage of all active nodes"
                style="
                  cursor: pointer;
                  overflow: inherit;
                  font-size: 1rem !important;
                "
                [size]="gaugeSize"
                type="arch"
                cap="round"
                matTooltipPosition="above"
                [value]="gpuMemoryGaugeValue"
                [label]="gpuMemoryGaugeLabel"
                [thick]="gaugeThick"
                [thresholds]="gaugeThresholds"
                [append]="gaugeAppendText"
                (mouseenter)="onGpuGaugeHover()"
                (mouseleave)="onGpuGaugeHover()"
              >
              </ngx-gauge>
            </div>
          </div>
          <div class="mt-5">
            <canvas
              baseChart
              #nodeUtilizationChart="base-chart"
              height="300px"
              [data]="nodeUtilizationData"
              [options]="nodeUtilizationOptions"
              [plugins]="nodeUtilizationPlugins"
              type="line"
            ></canvas>
          </div>
          <ngx-spinner 
            bdColor="rgba(0, 0, 0, 0.1)"
            size="default"
            zIndex="1"
            color="#0072c6"
            type="ball-spin"
            name="usage"
            [fullScreen]="false">
          </ngx-spinner>
        </div>
        <div class="w-48 mt-4 p-3 pt-0 shadow_block border-r-1 position-relative">
          <div class="mt-5">
            <div class="position-relative">
              <canvas baseChart height="250" #jobSessionsChart="base-chart" [data]="jobSessionsData"
                [options]="jobSessionsOptions" type="bar"></canvas>
            </div>
            <div class="position-relative">
              <canvas baseChart height="300" [data]="hpcUnitsConsumedDataTotal" [options]="hpcUnitsConsumedOptions"
                [type]="hpcUnitsConsumedType" [plugins]="hpcUnitsConsumedPlugins">
              </canvas>
            </div>
          </div>
          <ngx-spinner 
            bdColor="rgba(0, 0, 0, 0.1)"
            size="default"
            zIndex="1"
            color="#0072c6"
            type="ball-spin"
            name="session"
            [fullScreen]="false">
          </ngx-spinner>
          <ngx-spinner 
            bdColor="rgba(0, 0, 0, 0)"
            size="default"
            zIndex="1"
            color="#0072c6"
            type="ball-spin"
            name="hpcUnits"
            [fullScreen]="false">
          </ngx-spinner>
        </div>
        <div class="w-48 mt-4 p-3 pt-0 shadow_block border-r-1 position-relative">
          <canvas class="border-r-1" style="background-color: white;" #networkChart="base-chart" baseChart [height]="graphHeight" [data]="networkData" [options]="networkOptions" [type] ="networkType" [plugins]="networkPlugins">
          </canvas>
          <ngx-spinner 
            bdColor="rgba(0, 0, 0, 0.1)"
            size="default"
            zIndex="1"
            color="#0072c6"
            type="ball-spin"
            name="network"
            [fullScreen]="false">
          </ngx-spinner>
        </div>
        <div class="w-48 mt-4 p-3 pt-0 shadow_block border-r-1 position-relative">
          <canvas class="border-r-1" style="background-color: white;" #networkChart="base-chart" baseChart [height]="graphHeight" [data]="licenseUsageData" [options]="licenseUsageOptions" [type] ="licenseUsageType" [plugins]="licenseUsage">
          </canvas>
          <ngx-spinner 
            bdColor="rgba(0, 0, 0, 0.1)"
            size="default"
            zIndex="1"
            color="#0072c6"
            type="ball-spin"
            name="license"
            [fullScreen]="false">
          </ngx-spinner>
        </div>
      </div>
    </div>

    <div *ngIf="switchToGrafanaDashboard == true" style="overflow: auto;">
      <div>
        <iframe [src]="dashboardUrl" width="100%" height="800 px" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</div>
<ng-template #htmlContentTooltip>
  <div
    *ngIf="tooltipHtml != null"
    class="tooltipNodeName tooltip-content"
    [innerHTML]="tooltipHtml | safeHtml"
  ></div>
</ng-template>
